module.exports = __webpack_public_path__ + "assets/img/purchase.1fdb64b8.png";